import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from '../components/Layout';
import RoutePending from '../components/RoutePending';
import {
  Signup,
  Signin,
  MoreDetails,
  Service,
  Profile,
  ServiceDetail,
  Solution,
  Basket,
  SelectArea,
  SelectAreaLand,
  Payment,
  OrderDetails,
  Order,
  OrderList,
  OrderAnalys,
  OrderReport,
  ForgotPassword,
  HelpCenter,
  Wallet,
  OrderListDetail,
  ChangePassword,
  Home,
  ChatBot,
  OrderAnalysis,
  ReferralUser,
  NotFound,
  PrivacyPolicy,
  TermsAndConditions,
  AreaInterestAdd,
  AreaInterestList,
  SaveAddress,
} from './prefetch';

const publicRoutes = [
  { path: '/', Component: Signup },
  { path: '/signin', Component: Signin },
  { path: '/forgot-password', Component: ForgotPassword },
  { path: '/privacy-policy', Component: PrivacyPolicy },
  { path: '/terms-conditions', Component: TermsAndConditions },
  { path: '*', Component: NotFound },
];

const privateRoutes = [
  { path: '/home', Component: Home },
  { path: '/moredetails', Component: MoreDetails },
  { path: '/service', Component: Service },
  { path: '/profile', Component: Profile },
  { path: '/servicedetail', Component: ServiceDetail },
  { path: '/selectarea', Component: SelectArea },
  { path: '/solution', Component: Solution },
  { path: '/basket', Component: Basket },
  { path: '/selectarealand', Component: SelectAreaLand },
  { path: '/payment', Component: Payment },
  { path: '/orderdetails', Component: OrderDetails },
  { path: '/order', Component: Order },
  { path: '/orderlist', Component: OrderList },
  { path: '/orderlist-details', Component: OrderListDetail },
  { path: '/orderanalys', Component: OrderAnalys },
  { path: '/orderreport', Component: OrderReport },
  { path: '/helpcenter', Component: HelpCenter },
  { path: '/wallet', Component: Wallet },
  { path: '/chatbot', Component: ChatBot, remountOnNavigate: true },
  { path: '/change-password', Component: ChangePassword },
  { path: '/analysis-report', Component: OrderAnalysis },
  { path: '/refferal-users', Component: ReferralUser },
  { path: '/area-interests', Component: AreaInterestList },
  { path: '/area-interest-add', Component: AreaInterestAdd },
  { path: '/add-address', Component: SaveAddress },
];

// Linking to the page you are already on keeps React state; a new key per
// navigation restarts flows like the chatbot from the first step.
const FreshOnNavigate = ({ Component }) => {
  const location = useLocation();
  return <Component key={location.key} />;
};

const Approutes = () => {
  return (
    <div style={{ minHeight: '100dvh', height: '100%' }}>
      <Routes>
        {publicRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <RoutePending>
                <Component />
              </RoutePending>
            }
          />
        ))}
        {privateRoutes.map(({ path, Component, remountOnNavigate }) => (
          <Route
            key={path}
            path={path}
            element={
              <Layout>
                {remountOnNavigate ? (
                  <FreshOnNavigate Component={Component} />
                ) : (
                  <Component />
                )}
              </Layout>
            }
          />
        ))}
      </Routes>
    </div>
  );
};

export default Approutes;
